<div class="wrap">
  <h1>Dashboard</h1>

  <div class="content">
    <div class="maps_camera_select">
      <div class="maps">
        <agm-map
          [zoom]="zoom"
          [latitude]="lat"
          [longitude]="lng"
          fullscreenControl="true"
          [fitBounds]="false"
        >
          <agm-marker-cluster
            imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m"
          >
            <ng-container *ngFor="let d of dataSource?.filteredData">
              <agm-marker
                [agmFitBounds]="true"
                [latitude]="d.location.lat"
                [longitude]="d.location.lng"
                [zoom]="zoom"
              >
              </agm-marker>
            </ng-container>
          </agm-marker-cluster>
        </agm-map>
      </div>

      <form
        class="camera_select"
        [formGroup]="choiceDateForm"
        (ngSubmit)="onSubmit(false)"
      >
        <mat-form-field appearance="outline">
          <mat-label>From </mat-label>
          <input
            matInput
            [matDatepicker]="from"
            formControlName="from"
            [max]="today"
          />
          <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
          <mat-datepicker #from></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>To </mat-label>
          <input
            matInput
            [matDatepicker]="to"
            formControlName="to"
            [min]="from"
            [max]="today"
          />
          <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
          <mat-datepicker #to></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>State </mat-label>
          <mat-select formControlName="state">
            <mat-option>None</mat-option>
            <mat-option *ngFor="let etat of etats" [value]="etat">
              {{ etat.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Alert level </mat-label>
          <mat-select formControlName="level">
            <mat-option *ngFor="let niveau of niveaux" [value]="niveau">
              <fa-icon
                [icon]="faCircle"
                [ngClass]="{
                  green: niveau.value === 'Low',
                  orange: niveau.value === 'Medium',
                  red: niveau.value === 'High'
                }"
              >
              </fa-icon>
              {{ niveau.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Camera </mat-label>
          <mat-select formControlName="camera">
            <mat-option>None</mat-option>
            <mat-option [value]="c.id" *ngFor="let c of camera"
              >{{ c.name }}({{ c.externalId }})</mat-option
            >
          </mat-select>
        </mat-form-field>

        <div class="search">
          <button
            mat-raised-button
            class="reset"
            (click)="choiceDateForm.reset()"
          >
            Reset
          </button>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="choiceDateForm.invalid"
          >
            &nbsp;&nbsp;<fa-icon [icon]="faSearch"></fa-icon>
          </button>
          <!-- &nbsp are spaces to center the icon -> css doesn't work -->
        </div>
      </form>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="date"
      matSortDisableClear
      matSortDirection="desc"
      [hidden]="isLoading"
    >
      <ng-container matColumnDef="date">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          [style.text-align]="'center'"
        >
          Date
        </th>
        <td mat-cell *matCellDef="let element" class="cell_label">
          {{ element.date | date : "short" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="camera">
        <th mat-header-cell *matHeaderCellDef class="cell_action">Camera</th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          {{ element.camera.name }}({{ element.camera.externalId }})
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          [style.text-align]="'center'"
        >
          Alert level
        </th>
        <td mat-cell *matCellDef="let element" class="alertLevelCell">
          <mat-form-field appearance="outline">
            <mat-select
              [placeholder]="getStatusRoute(element?.status) | translate"
              [style.text-align]="'center'"
              (selectionChange)="putAlertLevel(element.id, $event)"
            >
              <mat-option
                *ngFor="let niveau of niveaux"
                [value]="niveau.value"
                [style.text-align]="'center'"
              >
                <fa-icon
                  [icon]="faCircle"
                  [ngClass]="{
                    green: niveau.value === 'Low',
                    orange: niveau.value === 'Medium',
                    red: niveau.value === 'High'
                  }"
                >
                </fa-icon>
                {{ niveau.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="etat">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          [style.text-align]="'center'"
        >
          State
        </th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <mat-form-field appearance="outline">
            <mat-select
              [placeholder]="getEtatRoute(element?.state) | translate"
              [style.text-align]="'center'"
              (selectionChange)="putEtat(element.id, $event)"
            >
              <mat-option
                *ngFor="let etat of etats"
                [value]="etat.value"
                [style.text-align]="'center'"
              >
                {{ etat.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="modifiedBy">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="cell_label"
          [style.text-align]="'center'"
        ></th>
        <td mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <mat-icon
            *ngIf="element.modifiedBy && element.modifiedOn"
            color="primary"
            [matTooltip]="getTooltip(element)"
          >
            info
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="localisation">
        <th mat-header-cell *matHeaderCellDef class="cell_action">Location</th>
        <td mat-cell *matCellDef="let element" class="cell_action">
          {{ element.Localisation }}

          <fa-icon
            [icon]="faMarker"
            (click)="updateMarker(element)"
            matTooltip="show location"
          >
          </fa-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef class="cell_action">Video</th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          class="cell_action"
        >
          <fa-icon
            [icon]="falink"
            [ngClass]="{
              isActive: hasVideo(element.medias),
              isDeactive: !hasVideo(element.medias)
            }"
            (click)="
              hasVideo(element.medias) ? openDialogInfoCamera(element, i) : null
            "
            matTooltip="show media"
          >
          </fa-icon>
          <!-- <fa-icon *ngIf="!hasVideo(element.medias)" [icon]="timeCircle"></fa-icon> -->
        </td>
      </ng-container>
      <ng-container matColumnDef="aperçu">
        <th mat-header-cell *matHeaderCellDef class="cell_action">Image</th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          class="cell_action cell_overview"
        >
          <fa-icon
            *ngIf="hasThumbnail(element.medias)"
            [icon]="faSearch"
            (click)="openDialogThumbnail(element, i)"
            matTooltip="Show preview"
          >
          </fa-icon>
          <fa-icon
            *ngIf="!hasThumbnail(element.medias)"
            [icon]="timeCircle"
            matTooltip="No media for this alert"
          ></fa-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      aria-label="Select page"
      [hidden]="isLoading"
    >
    </mat-paginator>
    <mat-spinner
      *ngIf="isLoading"
      [diameter]="100"
      color="primary"
    ></mat-spinner>
  </div>
</div>
